import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { BreadcrumbItem } from '@shared/components';
import { WindowService } from '@shared/window/window.service';
import { TitleComponent } from '../../shared/components/title/title.component';
import { ProjectsComponent } from '../components/projects/projects.component';

@Component({
    selector: 'app-eu-projects',
    templateUrl: './eu-projects.component.html',
    styleUrls: ['./eu-projects.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TitleComponent, ProjectsComponent],
})
export class EuProjectsComponent implements OnInit {
    private windowService = inject(WindowService);

    breadcrumbs: BreadcrumbItem[] = [
        {
            name: 'NAVIGATION.MAIN.main_page',
            url: '/',
        },
        {
            name: 'FOOTER.ADDITIONAL_INFORMATIONS.projects',
            url: '/eu-projects',
        },
    ];

    ngOnInit(): void {
        this.windowService.scrollTop();
    }
}
